import React, { useState, useEffect, useContext } from 'react';
import JobCostService from "../../Controller/JobCostController";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CreateJobCost from './CreateJobCost';
import JobService from "../../Controller/JobController";
import { handleInvoicing } from "../../Controller/CreateJobInvoicController";
import SaleOrderDetailModal from "../../../Invoice/View/InvoiceDetail";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import Swal from 'sweetalert2';
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import { API_URL, API_KEY } from "../../../../config/CurrencyConfig"
import CurrencyConverter from '../../../../config/CurrencyConverter';
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
import HelpSite from "../../../Common/HelpLink";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import JobAssetService from "../../Controller/JobAssetController";
import BASE_URL from "../../../../config/config";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import SendEmail from "../../../Common/SendAttachment";
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import { PDFDocument } from "pdf-lib";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
    Invoices: 22,
};
function JobsCostPage({ JobID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [JobCostList, setJobCostData] = useState([]);
    JobID = localStorage.getItem('JobID');
    const activeDateFormat = useDateFormat();
    const JobCostID = localStorage.getItem('JobCostID');
    const { theme } = useContext(ThemeContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalInvoiceOpen, setIsModalInvoiceOpen] = useState(false);
    const [EstimatedPrice, setEstimatedPrice] = useState("0.00");
    const [Currency, setCurrency] = useState("0.00");
    const [currentJobCost, setCurrentJobCost] = useState(null);
    const [totalSale, setTotalSale] = useState(null);
    const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
    const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
    const [BaseCurrency, setBaseCurrency] = useState(null);
    const [currencyList, setCurrencies] = useState([]);
    const [IsAuto, setIsAuto] = useState([]);
    const [ConvRate, setConvRate] = useState('1.00');
    const [Invoiced, setInvoiced] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");
    const [pdfUrl, setPdfUrl] = useState(null);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [imageData, setImageData] = useState(null);

    const [jobNo, setJobNo] = useState(null);
    const [jobDetail, setJobDetail] = useState(null);
    const [saleOrID, setSaleOrderID] = useState(null);
    const [invoiceNo, setInvoiceNo] = useState(null);
    const [DateInvoiced, setDateInvoiced] = useState(null);
    const [callType, setCallType] = useState(null);
    const [customerName, setCustomerName] = useState(null);
    const [companyName, setCompanyName] = useState(null);
    const [branchName, setBranchName] = useState(null);
    const [branchAddress, setBranchAddress] = useState(null);
    const [branchPhone, setBranchPhone] = useState(null);
    const [branchFax, setBranchFax] = useState(null);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [pdfBlob, setPdfBlob] = useState(null);
    const [pdfAttachment, setPdfAttachment] = useState(null); // Store PDF for Email
    const [loading, setLoading] = useState(false);
    const [assignedModules, setAssignedModules] = useState(new Set());
    const [reportTitle, setReportTitle] = useState('');
    const [reportLink, setReportLink] = useState('');
    const [error, setError] = useState(null);
    const [includeTerms, setIncludeTerms] = useState(false);
    const fetchJobCost = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await JobCostService.GetAllJobCost(redirectCallback, JobID);
            setJobCostData(data);
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };

    const fetchCurrencyConvRate = async (newCurrencySymbol) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const rateConv = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
            setConvRate(rateConv);
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };

    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');
            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
                SetIsClosed(jobDetail[0].IsCompleted);
                setBaseCurrency(listOfCurreny[0].Symbol)
                setEstimatedPrice(jobDetail[0].Estimate);
                setCurrency(jobDetail[0].Symbol);
                setIsAuto("0");
                setInvoiced(jobDetail[0].Invoiced);

                setJobNo(jobDetail[0].bnt_OrderNumber);
                setJobDetail(jobDetail[0].IssueTitle);
                setSaleOrderID(jobDetail[0].SaleOrderNo);
                setInvoiceNo(jobDetail[0].InvoiceNo);
                setDateInvoiced(jobDetail[0].DateInvoiced);
                setCallType(jobDetail[0].CallTypeID);
                setCustomerName(jobDetail[0].CustomerName);
                setCompanyName(jobDetail[0].CompanyName);
                setBranchName(jobDetail[0].BranchName);
                setBranchAddress(jobDetail[0].Address1);
                setBranchPhone(jobDetail[0].Phone1);
                setBranchFax(jobDetail[0].Fax);
                await fetchCurrencyConvRate(jobDetail[0].Symbol);
                if (jobDetail[0].CurrencyType == "Auto") {
                    setIsAuto("1");
                }
                // setEstimatedPrice(jobDetail[0].Estimate);
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));
        if (JobID > 0) {
            fetchCurrency();
            fetchJobDetail();
            fetchJobCost();
            fetchAssignedModules();

        }
        else {
            setJobCostData([]);
        }
    }, [JobID, JobCostID, localStorage.getItem("Closed")]);

    const handleCreateJobCostClick = () => {
        setCurrentJobCost(null);
        setIsModalOpen(true);
    };


    const handleCloseModal = () => {
        setIsModalOpen(false);
    };


    const handleEditClick = (job) => {
        setCurrentJobCost(job); // Set the notification to be edited
        setIsModalOpen(true);
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await JobCostService.DeleteJobCost(ID);
                    //  $(tableRef.current).DataTable().destroy();
                    await fetchJobCost();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };


    const handleSuccess = async () => {
        await fetchJobCost();
        handleCloseModal();   // Close the modal
    };

    // Calculate total cost and our cost
    const totalCost = JobCostList.reduce((sum, job) => sum + (parseFloat(job.mon_Cost) || 0), 0);
    const totalOurCost = JobCostList.reduce((sum, job) => sum + (parseFloat(job.mon_OurCost) || 0), 0);

    const amountToConvert = EstimatedPrice === "0"
        ? (totalCost - totalOurCost).toFixed(2)
        : (EstimatedPrice - totalCost).toFixed(2);


    // setTotalSale(totalCost);
    const HelpLink = localStorage.getItem('HelpLink');
    const redirectUserList = () => {
        navigate('/JobsList?saved=true');
    };
    const handleInvoice = async () => {
        const CostList = JobCostList.filter(cost => cost.Invoiced === "No");
        if (CostList.length > 0) {
            let message = "Are you sure to create invoice!";
            if (Invoiced) {
                message = "The invoice for the job has already been created. Do you still want to create?";
            }
            Swal.fire({
                title: 'Are you sure?',
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes,Create Invoice!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const data = {
                            mon_NetTotal: ConvRate * totalCost,
                            FK_Issue_ID: JobID,
                            mon_CostNetTotal: ConvRate * totalOurCost
                        };

                        const LastInvoiceID = await handleInvoicing(data);
                        localStorage.setItem('InvoiceID', LastInvoiceID);
                        setShowAssetDetailModal(true);

                        setIsModalInvoiceOpen(true);

                        let JobCostID = localStorage.getItem('JobCostID');
                        JobCostID = JobCostID + 1;
                        localStorage.setItem('JobCostID', JobCostID);
                        // redirectUserList();
                    } catch (error) {

                        console.error('Error invoicing job:', error);
                        Swal.fire(
                            'Error!',
                            'There was a problem invoicing the record.',
                            'error'
                        );
                    }
                }
            });
        }
        else {
            Swal.fire({
                title: '',
                text: `The invoice for the job has already been created.`,
                icon: 'warning'
            });
        }
    };
    const handleCloseSaleOrderModal = () => {
        setIsModalInvoiceOpen(false);
    };
    async function fetchAssetData() {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const formData = await JobAssetService.AssetIssue(redirectCallback, JobID); // Pass the language parameter
            return formData;

        } catch (error) {
            console.error('Error fetching Users:', error);
        }
    }

    const fetchJobEngineers = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };


            const formatDate = (dateString) => {
                if (!dateString) return null;
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const year = date.getFullYear();
                return `${year}/${month}/${day}`;
            };
            if (JobID > 0) {
                const jobEngineers = await JobService.GetJobEnginners(redirectCallback, JobID);

                const selectedPartsData = jobEngineers.map(detail => ({

                    UserID: detail.UserID,
                    EngineerTimeID: detail.EngineerTimeID,
                    DisplayName: detail.DisplayName,
                    DepartBaseDate: formatDate(detail.DepartBaseDate),
                    DepartBaseTime: detail.DepartBaseTime ? detail.DepartBaseTime.slice(0, 5) : "",
                    ReturnBaseDate: formatDate(detail.ReturnBaseDate),
                    ReturnBaseTime: detail.ReturnBaseTime ? detail.ReturnBaseTime.slice(0, 5) : "",
                    HoursTravel: detail.HoursTravel,
                    StartDate: formatDate(detail.StartDate),
                    StartTime: detail.StartTime ? detail.StartTime.slice(0, 5) : "",
                    EndDate: formatDate(detail.EndDate),
                    EndTime: detail.EndTime ? detail.EndTime.slice(0, 5) : "",
                    HoursDate: detail.HoursDate,
                    PayRateID: detail.PayRateID,
                    Other: detail.Other,

                    // Map other fields as needed
                }));

                return selectedPartsData;
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    const truncateTextPdf = (text, maxLength = 25) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }

                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);
    const getMergedPDFBlob = async (includeTerms = true) => {

        try {

            const currentInputValues = {
                ClientID: localStorage.getItem("CompanyID"),
                paramIssueId: JobID
            };

            const redirectCallback = () => {
                navigate('/');
            };

            // ================= MAIN REPORT =================

            let reportData = await ReportService.GetCompanyReports(
                redirectCallback,
                "10"
            );

            reportData = reportData.filter(
                x => x.IsDefault.toString() === "1"
            );

            const reportID =
                reportData.length > 0
                    ? reportData[0].ID
                    : 124;

            const JasperReport =
                await JasperReportService.GetJasperReportByID(reportID);

            let url = JasperReport[0].Link;

            setReportLink(url);

            setReportTitle(JasperReport[0].ReportTitle);

            // replace placeholders in main report
            Object.keys(currentInputValues).forEach((key) => {

                const placeholder = new RegExp(`{${key}}`, 'g');

                let value = currentInputValues[key];

                if (key === "ClientID") {

                    value = localStorage.getItem("CompanyID");

                } else if (key === "UserID") {

                    value = localStorage.getItem("UserID");

                }

                if (url.includes(`{${key}}`)) {

                    url = url.replace(placeholder, value);

                }

            });

            const queryObjMain = {
                ...currentInputValues,
                format: 'pdf',
                ReportName: JasperReport[0].ReportName,
                ReportType: JasperReport[0].ReportType,
                name: JasperReport[0].ReportName
            };

            const queryStringMain =
                new URLSearchParams(queryObjMain).toString();

            const responseMain = await axiosInstance.get(
                `/Dashboard/ProxyReport?${queryStringMain}`,
                { responseType: 'blob' }
            );

            const mainPdfBytes =
                await responseMain.data.arrayBuffer();

            // ================= MERGE PDFs =================

            const mergedPdf = await PDFDocument.create();

            const mainPdf =
                await PDFDocument.load(mainPdfBytes);

            const mainPages =
                await mergedPdf.copyPages(
                    mainPdf,
                    mainPdf.getPageIndices()
                );

            mainPages.forEach((page) =>
                mergedPdf.addPage(page)
            );

            // ================= TERMS PDF =================

            if (includeTerms) {

                const companySetup =
                    await CompanySetupController.GetCompanyByID(
                        redirectCallback,
                        localStorage.getItem("CompanyID")
                    );

                const termFile =
                    companySetup?.[0]?.TermFile;

                // Only attach second PDF if file exists
                if (termFile) {

                    const ClientID =
                        localStorage.getItem('CompanyID');

                    const FileUrl =
                        `${BASE_URL}/uploads/${ClientID}/Admin/TermConditions/${termFile}`;

                    const responseSecond =
                        await axiosInstance.get(
                            FileUrl,
                            { responseType: 'blob' }
                        );

                    const secondPdfBytes =
                        await responseSecond.data.arrayBuffer();

                    const secondPdf =
                        await PDFDocument.load(secondPdfBytes);

                    const secondPages =
                        await mergedPdf.copyPages(
                            secondPdf,
                            secondPdf.getPageIndices()
                        );

                    secondPages.forEach((page) =>
                        mergedPdf.addPage(page)
                    );
                }
            }

            const mergedPdfBytes =
                await mergedPdf.save();

            return new Blob(
                [mergedPdfBytes],
                { type: "application/pdf" }
            );

        } catch (err) {

            console.error("Error executing report:", err);

            setError("Failed to execute the report.");

            return null;
        }
    };





    const generatePDF = async (event) => {
        event.stopPropagation();

        try {

            const blob = await getMergedPDFBlob(false);

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);

            localStorage.setItem('HasRecordUpdated', "1");

        } catch (err) {
            console.error(err);
        }
    };
    const generatePDFForEmail = async (termsFlag) => {
        try {
            setLoading(true);

            const blob = await getMergedPDFBlob(termsFlag);

            const file = new File([blob], 'Invoice.pdf', {
                type: 'application/pdf'
            });

            setPdfAttachment(file);
            setIsEmailModalOpen(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };



    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const modules = await ModuleService.GetCompanyModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };

    const handlePrintUser = async (event) => {
        event.stopPropagation(); // Prevent the row click event


        try {

            const currentInputValues = {
                ClientID: localStorage.getItem("CompanyID"),
                paramIssueId: JobID
            };
            const JasperReport = await JasperReportService.GetJasperReportByID("124");
            let url = JasperReport[0].Link;
            setReportLink(url);
            setReportTitle(JasperReport[0].ReportTitle);

            // Replace placeholders {ClientID}, {UserID} dynamically
            const replacedKeys = {};
            Object.keys(currentInputValues).forEach((key) => {
                const placeholder = new RegExp(`{${key}}`, 'g');
                let value = currentInputValues[key];

                if (key === "ClientID") {
                    value = localStorage.getItem("CompanyID");
                } else if (key === "UserID") {
                    value = localStorage.getItem("UserID");
                }

                if (url.includes(`{${key}}`)) {
                    url = url.replace(placeholder, value);
                    replacedKeys[key] = true;
                }
            });

            // ✅ Build query object including *all* params
            const queryObj = {
                ...currentInputValues,
                format: 'pdf',
                ReportName: JasperReport[0].ReportName,
                ReportType: JasperReport[0].ReportType,
                name: JasperReport[0].ReportName
            };

            // ✅ Remove only ClientID and UserID if they exist


            // ✅ Convert to query string
            const queryString = new URLSearchParams(queryObj).toString();

            // ✅ Call proxy endpoint with query string
            const response = await axiosInstance.get(`/Dashboard/ProxyReport?${queryString}`, {
                responseType: 'blob' // important for PDF
            });

            // ✅ Convert Blob to Object URL
            const pdfObjectUrl = URL.createObjectURL(response.data);

            setPdfUrl(pdfObjectUrl);
            setShowPdfModal(true);


        } catch (err) {
            console.error('Error executing report:', err);
            setError('Failed to execute the report.');
        }


    };

    return (
        <div>
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-6">
                    <button className='btn btn-primary btn-sm' onClick={handleCreateJobCostClick} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                    {(assignedModules.has(MODULE_IDS.Invoices) &&
                        <button className='btn btn-secondary btn-sm' style={{ "marginLeft": "10px", background: "#2E7D32" }} onClick={handleInvoice} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                            <i className="icofont-file-alt" aria-hidden="true"> Invoice</i>
                        </button>
                    )}
                    <button style={{ "marginLeft": "5px" }} type="button" className="btn btn-secondary" onClick={generatePDF} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                        <i className="icofont-print" aria-hidden="true"></i> Print
                    </button>
                    <button style={{ "marginLeft": "5px" }} type="button" className="btn btn-email" onClick={() => generatePDFForEmail(includeTerms)} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                        <i className="icofont-email" aria-hidden="true"></i> Email
                    </button>
                </div>
                <div className="col-sm-6" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px", marginTop: "10px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <div className='divTable'>
                            <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                <thead>
                                    <tr>
                                        <th>Cost Type</th>
                                        <th>Item Name</th>
                                        <th>Description</th>
                                        <th>Invoiced</th>
                                        <th>Hours</th>
                                        <th>Date</th>
                                        <th>Rate Type</th>
                                        <th>Cost Price</th>
                                        <th>Sale Price</th>
                                        <th style={{ "textAlign": "right" }}>Actions</th>
                                    </tr>
                                </thead>
                            </table>
                            <div style={{ maxHeight: "430px", overflow: "auto" }}>
                                <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <tbody>
                                        {JobCostList.map((job, index) => (
                                            <tr key={job.PK_IssueCost_ID} onClick={(isClosed === '0' || isClosed === 0) ? () => handleEditClick(job) : undefined} style={{ cursor: 'pointer' }}>
                                                <td className="no-wrap">{job.CostType}</td>
                                                <td className="no-wrap" title={job.vc_CostName}>{job.vc_CostName}</td>
                                                <td className="no-wrap" title={job.vc_Description}>{job.vc_Description}</td>
                                                <td className="no-wrap">{job.Invoiced}</td>
                                                <td className="no-wrap">{job.TotalHours}</td>
                                                <td className="no-wrap">{formatDateWithFns(job.dt_EntryDate, activeDateFormat)}</td>
                                                <td className="no-wrap">{job.RateMethod}</td>

                                                <td className="no-wrap">{job.Symbol} {parseFloat(ConvRate * job.mon_OurCost).toFixed(2)} </td>
                                                <td className="no-wrap">{job.Symbol} {parseFloat(ConvRate * job.mon_Cost).toFixed(2)}</td>
                                                <td style={{ "textAlign": "right" }}>

                                                    <button style={{ "background": "none", "border": "none" }} className="text-danger" disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"} onClick={(event) => handleDeleteClick(event, job.PK_IssueCost_ID)}>
                                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td><strong> Total</strong></td>


                                            <td>{Currency}{parseFloat(totalOurCost || 0).toFixed(2)}</td>
                                            <td>{Currency}{parseFloat(totalCost || 0).toFixed(2)}</td>

                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>


                                            <td><strong>Gross Profit</strong></td>
                                            <td></td>

                                            <td>{Currency}
                                                <CurrencyConverter
                                                    baseCurrency={BaseCurrency}
                                                    targetCurrency={Currency}
                                                    amount={totalCost - totalOurCost}
                                                    currencyList={currencyList}
                                                    IsAuto={IsAuto}
                                                />
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>


                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>

                                            <td colSpan={2}><strong>Estimated</strong></td>
                                            <td>{Currency} {<CurrencyConverter baseCurrency={BaseCurrency} targetCurrency={Currency} amount={EstimatedPrice} currencyList={currencyList} IsAuto={IsAuto} />}</td>

                                            <td></td>
                                            <td></td>
                                            <td></td>

                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>

                                            <td colSpan={2}><strong>Net Profit</strong></td>
                                            <td>
                                                {Currency}{' '}
                                                {EstimatedPrice <= 0 ? (
                                                    <CurrencyConverter
                                                        baseCurrency={BaseCurrency}
                                                        targetCurrency={Currency}
                                                        amount={totalCost - totalOurCost}
                                                        currencyList={currencyList}
                                                        IsAuto={IsAuto}
                                                    />
                                                ) : (
                                                    <CurrencyConverter
                                                        baseCurrency={BaseCurrency}
                                                        targetCurrency={Currency}
                                                        amount={EstimatedPrice - totalOurCost}
                                                        currencyList={currencyList}
                                                        IsAuto={IsAuto}
                                                    />
                                                )}


                                            </td>

                                            <td></td>
                                            <td></td>
                                            <td></td>

                                        </tr>


                                    </tbody>
                                </table>
                            </div>
                            <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                <tfoot style={{ "background": "#eee7e7" }}>

                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Generated PDF</h5>
                                <button type="button" className="close" onClick={() => setPdfUrl(null)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <iframe
                                    id="pdf-iframe"
                                    src={pdfUrl}
                                    title="PDF Viewer"
                                    style={{ width: '100%', height: '600px', border: 'none' }}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        const iframe = document.querySelector('iframe');
                                        if (iframe) iframe.contentWindow.print(); // Trigger print
                                    }}
                                >
                                    Print
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {isModalOpen && (
                <CreateJobCost
                    currentJobCost={currentJobCost}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    JobID={JobID}
                />
            )}
            {isModalInvoiceOpen && (
                <SaleOrderDetailModal InvoiceID={localStorage.getItem('InvoiceID')} onClose={handleCloseSaleOrderModal} />
            )}
            {isEmailModalOpen && (
                <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} pdfAttachment={pdfAttachment} />
            )}
        </div>
    );
}

export default JobsCostPage;
